import { render, staticRenderFns } from "./common-addon.vue?vue&type=template&id=40a04f83"
import script from "./common-addon.vue?vue&type=script&lang=js"
export * from "./common-addon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports